export enum scoutsCandidateTypes {
  FETCH_SCOUTS_CANDIDATE_REQUEST = "FETCH_SCOUTS_CANDIDATE_REQUEST",
  FETCH_SCOUTS_CANDIDATE_SUCCESS = "FETCH_SCOUTS_CANDIDATE_SUCCESS",
  FETCH_SCOUTS_CANDIDATE_FAILURE = "FETCH_SCOUTS_CANDIDATE_FAILURE",
}